import './styles.scss';

export default {
    name: 'OpacityDropdown',

    data() {
        return {
            current: ''
        }
    },

    methods: {
        chooseOpacity(opacity) {
            this.current = opacity;
            this.$ionic.popoverController.dismiss(opacity);
        },
    }
};